<app-spinner [(show)]="loading"></app-spinner>

<ng-container *ngIf="!loading">

  <main class="esf-main-content esf-main-content--has-sidebar -has-transition" style="width: 100vw" [class.-is-open]="isOpened">
    <div class="esf-container main-content--full-screen" [class.full-screen-opened]="isOpened">

      <h1 class="esf-heading esf-heading--page esf-action-heading">
        <span class="esf-action-heading__text" i18n="@@tixxSelect.heading.lotteryPreparation">
          Lottery Preparation
        </span>
      </h1>

      <h4>
        <span>Event</span>
        <span>: </span>
        <span>
          {{ selectedLottery.event.date.date | date: 'dd.MM.yyyy' }}
          {{ selectedLottery.event.getFormattedEventName() }}
        </span>
      </h4>

      <form [formGroup]="lotteryPreparationForm" (ngSubmit)="formSubmit(lotteryPreparationForm)" id="lotteryPreparationForm">

        <div class="esf-form-group">
          <div app-form-field-text-generic
               class="esf-form-item--1-2"
               [control]="lotteryPreparationForm.controls['customer.firstName']"
               [placeholder]="flTranslations.i18nFirstName"
               [label]="flTranslations.i18nFirstName">
          </div>

          <div app-form-field-text-generic
               class="esf-form-item--1-2"
               [control]="lotteryPreparationForm.controls['customer.lastName']"
               [placeholder]="flTranslations.i18nLastName"
               [label]="flTranslations.i18nLastName">
          </div>
        </div>
        <div class="esf-form-group">
          <div app-form-field-text-generic
               class="esf-form-item--1-4"
               [control]="lotteryPreparationForm.controls['customer.postalCode']"
               [placeholder]="flTranslations.i18nPostCode"
               [label]="flTranslations.i18nPostCode">
          </div>
          <div app-form-field-text-generic
               class="esf-form-item--3-4"
               [control]="lotteryPreparationForm.controls['customer.street']"
               [placeholder]="flTranslations.i18nStreet"
               [label]="flTranslations.i18nStreet">
          </div>
        </div>
        <div class="esf-form-group">

          <div app-form-field-multiselect
               class="esf-form-item--1-2"
               [control]="lotteryPreparationForm.controls['customer.attributes[]']"
               [label]="flTranslations.i18nAttributes"
               [multiselectData]="multiselectData">
          </div>

          <div app-form-field-text-generic
               class="esf-form-item--1-2"
               [control]="lotteryPreparationForm.controls['orderRequest.bankAccount.iban']"
               [placeholder]="flTranslations.i18nIBAN"
               [label]="flTranslations.i18nIBAN">
          </div>
        </div>
        <div class="esf-form-group">
          <div app-form-field-text-generic
               [control]="lotteryPreparationForm.controls['customer.email']"
               [placeholder]="flTranslations.i18nEmail"
               [label]="flTranslations.i18nEmail">
          </div>
          <div app-form-field-select
               [control]="lotteryPreparationForm.controls['priority.name']"
               [label]="flTranslations.i18nPriority"
               [array]="priorityDropdown">
          </div>
        </div>
        <app-submit-row-buttons style="max-width: calc(720px + 2rem);"
                                [form]="'lotteryPreparationForm'"
                                [cancelButtonText]="buttonsTranslations.i18nResetFilterSettings"
                                [submitButtonText]="buttonsTranslations.i18nShowRequests"
                                (cancelButton)="lotteryPreparationForm.reset({'priority.name': ''}); multiselectData.length = 0">
        </app-submit-row-buttons>

      </form>

      <div style="height: 40px"></div>

      <app-paginated-table [columns]="columns"
                           [keys]="keys"
                           [data]="currentSubmissions"
                           [actionButtons]="actionButtons"
                           [initialLoad]="false"
                           (rowButtonClickEvent)="actionButtonClicked($event)"

                           [baseApi]="baseApi"
                           [customQueries]="customQueries"
                           (dataFetchedEmitter)="createSubmissionObject($event)"

                           [emptyStateText]="i18nEmptyState"
                           [emptyStateIcon]="'#esf-icon-clover-leaf-48'">

      </app-paginated-table>

    </div>
  </main>

</ng-container>
